import React, { useState } from "react";
import "./getInTouchComponent.scss";
import { Form, Button, Row, Col, Container, FormLabel } from "react-bootstrap";

const GetInTouch = () => {
  return (
    <div className="main-container">
      <ContactText />
      <ContactForm />
    </div>
  );
};

const ContactText = () => {
  return (
    <div className="container">
      <div className="header">
        <p className="header-title">Get in Touch</p>
        <p>
          Contact us today to explore how our tailored solutions can support your business objectives. You can reach us by filling out the contact form or emailing us at info@cubeglobalservices.com, and we’ll begin the path to success together.
        </p>
      </div>

      <div className="contact-info">
        <p>CUBE GLOBAL SERVICES LTD.</p>
        <p>Arthur Evelyn Building, Suite 5,
          Main Street, Charlestown, Nevis
        </p>
        <p> +381 60 333 5726 </p>
        <p>info@cubeglobalservices.com</p>
        <p></p> 
      </div>
    </div>
  );
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <Container className="contact-container">
      <Form onSubmit={handleSubmit}>
        <div className="form-row-container">
          <Row>
            <Col md={6}>
              <Form.Group controlId="formFirstName" className="form-group">
                <Form.Label className="form-label">First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Input your First Name in Here"
                  className="form-control"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formLastName" className="form-group">
                <Form.Label className="form-label">Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Input your Last Name in Here"
                  className="form-control"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="formEmail" className="form-group">
                <Form.Label className="form-label">Email Address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Input your Email Address in Here"
                  className="form-control"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formPhone" className="form-group">
                <Form.Label className="form-label">Phone Number</Form.Label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Form.Control
                    as="select"
                    name="phonePrefix"
                    value={formData.phonePrefix}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#E1E1E1",
                      border: "1px solid #ced4da",
                      appearance: "none",
                      width: "75px",
                      marginRight: "0",
                      borderRight: "none",
                    }}
                  >
                    <option value="+1">+1</option>
                    <option value="+40">+40</option>
                    <option value="+1 869">+1 869</option>
                    <option value="+44">+44</option>
                    <option value="+91">+91</option>

                  </Form.Control>

                  <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Input your Phone Number"
                    className="form-control"
                    style={{
                      border: "1px solid #ced4da",
                      borderLeft: "none",
                    }}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formMessage" className="form-group">
            <Form.Label className="form-label">Message</Form.Label>
            <Form.Control
              as="textarea"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              placeholder="Type your message here"
              className="form-control"
            />
          </Form.Group>
        </div>

        <div className="form-submit-container">
          <Button type="submit" className="btn-submit">
            Send Message
          </Button>
        </div>
      </Form>
    </Container>
  );
};
export default GetInTouch;
